import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Bar } from 'react-chartjs-2'
import { capitalize } from 'lodash'
import { isPDFGenerationModeEnabled } from '../../lib/utils/isPDFGenerationModeEnabled'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
)
const disableAnimations = isPDFGenerationModeEnabled()
  ? {
      animation: false,
    }
  : {}
const options = {
  disableAnimations,
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: 8,
  },
  plugins: {
    legend: {
      display: true,
      position: 'top',
      align: 'end',
    },
    crosshair: {
      line: {
        color: '#121124', // crosshair line color
        width: 1, // crosshair line width
      },
    },
    line: {
      color: '#FCD',
    },
    tooltip: {
      mode: 'index' as const,
      intersect: false,
    },
    datalabels: {
      display: true,
    },
  },
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
      ticks: {
        // @ts-ignore
        callback: function (val, index) {
          // @ts-ignore
          return '   ' + this.getLabelForValue(val)
        },
      },
    },
  },
}

const colors = ['rgba(255, 181, 181, 0.5)', 'rgba(0, 56, 255, 0.5)']

const StackedBarChart = ({
  data,
  isLoading = false,
  isPreviousData = false,
  yKeys,
  xKey,
  customOptions,
}: {
  data: Array<any>
  isLoading: boolean
  isPreviousData?: boolean
  yKeys: Array<string>
  xKey: string
  customOptions?: Record<string, unknown>
}): JSX.Element => {
  const chartData = {
    labels: data.map((v) => v[xKey]),
    datasets: yKeys.map((yKey, index) => ({
      label: capitalize(yKey),
      data: data.map((v) => v[yKey]),
      fill: true,
      datalabels: {
        anchor: 'end',
        align: 'start',
        color: '#FFF',
        font: {
          size: '12',
          weight: 'bold',
          fontFamily: 'Spartan',
        },
        padding: {
          top: 32,
        },
      },
      backgroundColor: colors[index],
    })),
  }
  if (isLoading) {
    return (
      <div className={'w-full h-full flex items-center justify-center'}>Loading...</div>
    )
  }

  if (data.length === 0) {
    return (
      <div className={'w-full h-full flex items-center justify-center opacity-50'}>
        <Bar
          options={{
            ...options,
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                mode: 'index' as const,
                intersect: false,
              },
            },
          }}
          data={{
            labels: data.map((v) => v[xKey]),
            datasets: [
              {
                label: '',
                data: [],
                borderWidth: 0,
                datalabels: {
                  display: false,
                },
              },
            ],
          }}
        />
      </div>
    )
  }

  return (
    <div className={'w-full h-full relative'}>
      {isPreviousData && (
        <div className={'absolute top-0 left-0 w-full h-full bg-white opacity-50'} />
      )}
      {/* @ts-ignore */}
      <Bar options={{ ...options, ...customOptions }} data={chartData} />
    </div>
  )
}

export default StackedBarChart
